import { styled } from '@mui/material';

const Container = styled('div')`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  @font-face {
    font-family: 'Manrope';
    font-weight: normal;
    font-style: normal;
    src: local('Manrope Regular'), url('/fonts/Manrope-Regular.ttf') format('truetype');
  }
  font-family: 'Manrope', sans-serif;

  &.cn {
    @font-face {
      font-family: 'LXGWWenKaiMonoTC';
      src: url('/fonts/LXGWWenKaiMonoTC-Regular.ttf') format('truetype');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }

    * {
      font-family: 'LXGWWenKaiMonoTC', sans-serif !important;
    }
  }
`;

export default Container;
